import { useState } from "react";
import { navItems } from "@/mocks/home";

export default function Header() {
  const [active, setActive] = useState("首页");
  const [menuOpen, setMenuOpen] = useState(false);
  const [query, setQuery] = useState("");

  return (
    <>
      <div className="hidden bg-foreground-950 text-background-100 sm:block">
        <div className="mx-auto flex h-9 max-w-[1280px] items-center justify-between px-4 text-xs md:px-6">
          <p className="flex items-center gap-2">
            <i className="ri-flashlight-fill text-accent-400"></i>
            久久视频 · 免费影视资源聚合站，每日更新不断档
          </p>
          <div className="flex items-center gap-4 text-background-200">
            <span className="cursor-pointer transition-colors hover:text-accent-400">APP 下载</span>
            <span className="cursor-pointer transition-colors hover:text-accent-400">意见反馈</span>
            <span className="cursor-pointer transition-colors hover:text-accent-400">帮助中心</span>
          </div>
        </div>
      </div>

      <div className="sticky top-0 z-50 border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-[1280px] items-center gap-4 px-4 md:px-6">
          <a href="#top" className="flex shrink-0 cursor-pointer items-center gap-2">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-2xl text-background-50">
              <i className="ri-play-circle-fill"></i>
            </span>
            <span className="leading-none">
              <span className="block font-heading text-2xl text-foreground-950">久久视频</span>
              <span className="mt-0.5 block text-[10px] tracking-[0.22em] text-primary-600">
                JIUJIU VIDEO
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setActive(item.label)}
                className={`whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                  active === item.label
                    ? "bg-primary-100 font-medium text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-2 md:gap-3">
            <div className="hidden h-10 w-40 items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 lg:flex">
              <i className="ri-search-line text-sm text-foreground-400"></i>
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜索片名 / 演员 / 标签"
                className="h-full w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
            </div>
            <button
              type="button"
              className="hidden h-10 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:flex"
            >
              <i className="ri-user-smile-line"></i>
              登录 / 注册
            </button>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="打开菜单"
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-xl text-foreground-800 lg:hidden"
            >
              <i className={menuOpen ? "ri-close-line" : "ri-menu-line"}></i>
            </button>
          </div>
        </div>

        {menuOpen ? (
          <div className="border-t border-background-200 bg-background-50 lg:hidden">
            <div className="mx-auto max-w-[1280px] px-4 py-4 md:px-6">
              <div className="mb-3 flex h-10 items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3">
                <i className="ri-search-line text-sm text-foreground-400"></i>
                <input
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="搜索片名 / 演员 / 标签"
                  className="h-full w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
                />
              </div>
              <div className="flex flex-wrap gap-2">
                {navItems.map((item) => (
                  <a
                    key={item.label}
                    href={item.href}
                    onClick={() => {
                      setActive(item.label);
                      setMenuOpen(false);
                    }}
                    className={`whitespace-nowrap rounded-md px-3 py-2 text-sm ${
                      active === item.label
                        ? "bg-primary-100 font-medium text-primary-700"
                        : "bg-background-100 text-foreground-700"
                    }`}
                  >
                    {item.label}
                  </a>
                ))}
              </div>
              <button
                type="button"
                className="mt-3 flex w-full cursor-pointer items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
              >
                <i className="ri-user-smile-line"></i>
                登录 / 注册
              </button>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
}